import React from 'react';
import '../../reports.scss';
import { formatDateSymbol } from '../../../../../utils/constant';
import { IoIosArrowRoundDown, IoIosArrowRoundUp } from 'react-icons/io';

// Map API label → metrics key
const formatLabel = (label) => {
	return label
		.replace(/_/g, ' ') // replace _ with space
		.replace(/\b\w/g, (c) => c.toUpperCase()); // capitalize
};

export default function ReportTable({
	activeTab,
	metaData,
	data,
	selectedColumnsList,
	type,
	setParams,
	sortDirection,
	setSortDirection,
}) {
	const sortIconMap = {
		asc: <IoIosArrowRoundUp />,
		desc: <IoIosArrowRoundDown />,
	};
	const sortDataList = (param) => {
		const newDirection = sortDirection[param.order_by] === 'desc' ? 'asc' : 'desc';
		setSortDirection({ [param.order_by]: newDirection });
		setParams((prev) => ({
			...prev,
			order_by: newDirection,
			sort_by: param.order_by,
		}));
	};
	const periods = metaData.periods;

	function getReportTypeKey(status) {
		switch (status.trim()) {
			case 'Sale By Customers':
				return 'customer_name';
			case 'Sale By Products':
				return 'product_name';
			default:
				return '';
		}
	}
	function getReportTypeLabel(status) {
		switch (status.trim('')) {
			case 'Sale By Customers':
				return 'Name';
			case 'Sale By Products':
				return 'Product Name';
			default:
				return '';
		}
	}

	return (
		<div>
			<div className="report-table-container">
				<table className="report-table">
					<thead>
						{/* Top Header */}
						<tr>
							<th
								onClick={() => {
									if (type !== 'compareTable') {
										sortDataList({ order_by: getReportTypeKey(activeTab) });
									}
								}}
								rowSpan={2}
								className={`${type === 'compareTable' ? 'name-col' : 'text-left cursor-pointer'} `}
								style={{ textAlign: 'left' }}
							>
								<div className="d-flex justify-content-start align-items-center gap-4">
									{getReportTypeLabel(activeTab)}
									{type !== 'compareTable'
										? sortIconMap[sortDirection[getReportTypeKey(activeTab)]]
										: ''}
								</div>
							</th>
							{type === 'compareTable' &&
								periods.map((p, i) => (
									<th
										key={i}
										colSpan={selectedColumnsList.length}
									>
										{`${formatDateSymbol(p.from_date)} - ${formatDateSymbol(p.to_date)}`}
									</th>
								))}
						</tr>

						{/* Sub Header */}
						<tr>
							{periods.map((p, i) =>
								selectedColumnsList.map((m, idx) => (
									<th
										className={`${type !== 'compareTable' ? 'cursor-pointer' : ''}`}
										key={`${i}-${idx}`}
										onClick={() => {
											if (type !== 'compareTable') {
												sortDataList({ order_by: m.key });
											}
										}}
									>
										<div className="d-flex justify-content-center align-items-center gap-4">
											{m.label}
											{type !== 'compareTable' ? sortIconMap[sortDirection[m.key]] : ''}
										</div>
									</th>
								)),
							)}
						</tr>
					</thead>

					<tbody>
						{data.map((item) => (
							<tr key={item}>
								<td className="name-col">
									{`${item[getReportTypeKey(activeTab)]} `}
									{activeTab === 'Sale By Products' ? ` ( ${item.product_code} ) ` : ''}
								</td>

								{periods.map((p, i) => {
									const key = formatLabel(p.label);
									const metrics = item.metrics[key] || {};

									return selectedColumnsList.map((m, idx) => (
										<td key={`${i}-${idx}`}>{metrics[m.key] ?? 0}</td>
									));
								})}
							</tr>
						))}
					</tbody>
				</table>
			</div>
		</div>
	);
}
